import {
    FETCH_CORPORATE_EARNING,
    FETCH_CORPORATE_EARNING_SUCCESS,
    FETCH_CORPORATE_EARNING_FAILED,
  } from "../store/types";
  import store from '../store/store';
    import { firebase } from '../config/configureFirebase';
    import { get, onValue } from "firebase/database";
  
  export const fetchCorporateEarnings = (uid,role) => async (dispatch)  => {
  
    const {
      settingsRef,
      bookingListRef
    } = firebase;
  
    dispatch({
      type: FETCH_CORPORATE_EARNING,
      payload: null
    });
  
    // const userInfo = store.getState().auth.profile;
    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();

    onValue(bookingListRef(uid, role), snapshot => {

        if (snapshot.val()) {
          const mainArr = snapshot.val();
          var monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
          var renderobj = {};
          Object.keys(mainArr).map(j => {
  
            if ((mainArr[j].status === 'PAID' || mainArr[j].status === 'COMPLETE') && mainArr[j].corporateAdminId && mainArr[j].corporateAdmin_share) {
              let bdt = new Date(mainArr[j].tripdate);
              let uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth() + '_' + mainArr[j].corporateAdminId;
              if (renderobj[uniqueKey] && renderobj[uniqueKey].corporateShare) {
                renderobj[uniqueKey].corporateShare = (parseFloat(renderobj[uniqueKey].corporateShare) + parseFloat(mainArr[j].corporateAdmin_share)).toFixed(2);
                renderobj[uniqueKey]['total_rides'] = renderobj[uniqueKey]['total_rides'] + 1;
              } else {
                renderobj[uniqueKey] = {};
                renderobj[uniqueKey]['dated'] = mainArr[j].tripdate;
                renderobj[uniqueKey]['year'] = bdt.getFullYear();
                renderobj[uniqueKey]['month'] = bdt.getMonth();
                renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
                renderobj[uniqueKey]['corporateAdminName'] = mainArr[j].corporateAdminName;
                renderobj[uniqueKey]['corporateShare'] = parseFloat(mainArr[j].corporateAdmin_share).toFixed(2);
                renderobj[uniqueKey]['corporateAdminId'] = mainArr[j].corporateAdminId;
                renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
                renderobj[uniqueKey]['total_rides'] = 1;
              }
            }
            return null;
          });
          if (renderobj) {
            const arr = Object.keys(renderobj).map(i => {
              renderobj[i].corporateShare = parseFloat(renderobj[i].corporateShare).toFixed(2)
              return renderobj[i]
            })
            dispatch({
              type: FETCH_CORPORATE_EARNING_SUCCESS,
              payload: arr
            });
          }
  
        } else {
          dispatch({
            type: FETCH_CORPORATE_EARNING_FAILED,
            payload: "No data available."
          });
        }
      });
  };
  
  